// extracted by mini-css-extract-plugin
export default {"teamName":"TeamMasterContainer__teamName___qvlS1"};